import type { PermissionsColumnKey } from "@/modules/permissions";
export const PERMISSIONS_SEARCH_PLACEHOLDER = "Buscar código, nome...";

/** Nome base do arquivo exportado quando o serviço não informa um. */
export const PERMISSIONS_EXPORT_FILE_NAME = "permissoes";
export const PERMISSIONS_EXPORT_LIST_NAME = "permissões";

export const PERMISSIONS_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar as permissões do Hub.";
export const PERMISSIONS_ERROR_MESSAGE = "Não foi possível carregar as permissões.";

export const PERMISSIONS_LOADING_LABEL = "Carregando permissões...";
export const PERMISSIONS_ROWS_PER_PAGE_LABEL = "Permissões por página";
export const PERMISSIONS_TABLE_LABEL = "Permissões cadastradas";

/** MS001 — confirmação da edição concluída. */
export const UPDATE_SUCCESS_MESSAGE = "Permissão atualizada com sucesso.";
export const UPDATE_ERROR_MESSAGE = "Não foi possível atualizar a permissão.";
export const UPDATE_FORBIDDEN_MESSAGE = "Você não tem permissão para editar as permissões do Hub.";

export type { PermissionsColumnKey };

export const PERMISSIONS_ACTIONS_KEY = "acoes";

/**
 * Colunas de dado do Figma 4434:39407, na ordem da tabela; as Ações fecham a linha. O Código é a claim do catálogo e o
 * Nome, o rótulo.
 */
export const PERMISSIONS_COLUMNS = [
  { key: "codigo", header: "Código", width: "10.9375rem" },
  { key: "nome", header: "Nome", width: "15rem" },
  { key: "descricao", header: "Descrição", width: undefined },
] as const;

/** Todas as colunas, na ordem da tabela: com 6 ou menos a seção de colunas do Configurações da Tabela não aparece. */
export const PERMISSIONS_ALL_COLUMNS: readonly PermissionsColumnKey[] = [
  ...PERMISSIONS_COLUMNS.map(({ key }) => key),
  PERMISSIONS_ACTIONS_KEY,
];

export const PERMISSIONS_ACTIONS_HEADER = "Ações";
export const PERMISSIONS_ACTIONS_WIDTH = "6.625rem";
/** Abaixo disso a tabela rola na horizontal em vez de espremer as colunas. */
export const PERMISSIONS_TABLE_MIN_WIDTH = "45rem";
